import { useQuery } from '@tanstack/react-query';
import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import { apiQueryClient } from '../../App';
import { contactIdOf } from './sessionIdentity';

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL
const cookies = new Cookies({
    expires: new Date(Date.now()+(60000*60*24*365)),
    maxAge: (60000*60*24*365)
  });
const opt: any =  {
    expires: new Date(Date.now()+(60000*60*24*365)),
    path: '/'
  }

export function welcomeBanner(hide=false) {
    if(hide) {
        cookies.set('feature_banner1','shown', opt)
        return false
    } 
    const welcome = cookies.get('feature_banner1')
    if(welcome==='shown') return false;
    return true;
}

export function savePromptAnswer(dismiss=false) {
    if(dismiss) cookies.set('hotwater_prompt', "clicked", opt);
    else window.sessionStorage.setItem('hotwater_prompt','clicked')
}

export function getPromptAnswer() {
    return (
        cookies.get('hotwater_prompt') || 
        window.sessionStorage.getItem('hotwater_prompt')
    );
}

export function getCurrentAccount() {
    const customer: any = apiQueryClient?.getQueryData(['Customer'])
    return {
        contactId: customer?.contactId, // || cookies.get('contact_id'),
        siteId: customer?.account?.siteId, // || cookies.get('site_id'),
        timezone: customer?.account?.timezone || cookies.get('timezone'),
        providerId: customer?.provider?.id, // || cookies.get('provider_id'),
        hasUsageData: customer?.hasUsageData,
        hasTou: customer?.provider?.isDynamicGridPricing,
    }
}

export async function getCustomer(session: any) {
    if(!session?.idToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/customers`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    const cust = await res.json();
    cookies.set('timezone', cust?.account?.timezone, opt)
    // The BFF does not return the contact id; keep the one this customer was fetched for, so a
    // session that changes underneath the cache can be recognised (sessionIdentity.ts).
    return { ...cust, contactId: contactIdOf(session?.idToken) }
}


export const useGetCustomer = (session: any) => {
    const {
        refetch: refetchCustomer, 
        error: errorCustomer, 
        data: customer 
    } = useQuery( {
        queryKey: ['Customer'], // key must be unique
        queryFn: ()=>getCustomer(session),
        staleTime: (60000 * 60)
    })

    return { errorCustomer, customer, refetchCustomer }
};
  

